/* eslint-disable import/prefer-default-export */
export const remotesWithDashboardCount = record =>
  (record.sources_list.includes('dashboard') ? record.remote_count : record.remote_count + 1);
